import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";

export const UploadKYCDoc = async () => {
  const sessionid = getSessionId();

  const requestData = {
    params: {
      context: {},
      data: {
        document_type: `${localStorage.getItem("docType")}`,
        document_name: localStorage.getItem("docName"),
        customer_id: Number(localStorage.getItem("customerId")),
        document_name_text: `${localStorage.getItem("fileName")}`,
        attachment_ids: [Number(localStorage.getItem("attachmentid"))],
        customer_key_person_id: "",
        is_keyperson: false,
      },
    },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer_kyc_document`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    );

    return response;
  } catch (error) {
    // console.error("Upload KYC Doc Error:", error);
    throw error;
  }
};
